const DEFAULT_SPACING = 8;

export const SPACING = {
  extraTiny: 3, //3px
  tiny: 6, // 6px
  default: DEFAULT_SPACING, // 8px
  small: DEFAULT_SPACING, // 8px
  medium: DEFAULT_SPACING * 1.5, // 12px
  large: DEFAULT_SPACING * 2, // 16px
  extraLarge: DEFAULT_SPACING * 3, // 24px
};

export const MOBILE_NAVBAR_SCREEN_WIDTH = 960;

export const NAVBAR_HEIGHT = 60;

export default SPACING;
